import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ReplaySubject, Observable, forkJoin } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
@Injectable({
    providedIn: 'root'
})
export class Utility {
    private _loadedLibraries: { [url: string]: ReplaySubject<any> } = {};
    constructor(private _localStorageService: LocalStorageService, private tosterservices: ToastrService,
        @Inject(DOCUMENT) private readonly document: any) { }
    // password and confirm password check
    MustMatch(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];

            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                return;
            }

            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        }
    }

    showSuccess(msg) {
        this.tosterservices.success(msg)
    }
    showError(msg) {
        this.tosterservices.error(msg)
    }
    showProcess(message: String, id) {
        return this.tosterservices.show(message.toString(), '', { positionClass: 'toast-bottom-center',
        toastClass: 'ngx-toastr process-toaster', timeOut: 0, tapToDismiss: false }).toastId = id;
    }
    public loadScript(url) {
        let body = <HTMLDivElement>document.body;
        let script = document.createElement('script');
        script.innerHTML = '';
        script.src = url;
        script.async = true;
        script.defer = true;
        body.appendChild(script);
    }

    toFormData(data, form, name?) {
        if (typeof data === 'object' && data != undefined) {
            for (let key in data) {
                if (data[key]) {
                    if (typeof data[key] === 'object' && data[key] != null && !(data[key] instanceof File)) {
                        if (name)
                            this.toFormData(data[key], form, name + '[' + key + ']')
                        else {
                            this.toFormData(data[key], form, key)
                        }
                    }
                    else {
                        if (!name)
                            form.append(key, data[key]);
                        else
                            form.append(name + '[' + key + ']', data[key]);
                    }
                }

            }
        }
        else {
            form.append(name, data);
        }

        return form;
    }
}
